import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@material-ui/core';
import LabPagination from '@material-ui/lab/Pagination';
import LabPaginationItem from '@material-ui/lab/PaginationItem';

import useStyles from './styles';

const Pagination = ({ amount, total, ...props }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <div className={classes.container}>
      <Typography variant="body1">
        {t('Showing')} <b>{amount}</b> {t('of')} <b>{total}</b> {t('items')}
      </Typography>
      <div className={classes.paginationContainer}>
        {!!total && (
          <>
            <Typography variant="body1" className={classes.page}>
              {t('Page')}
            </Typography>
            <LabPagination
              variant="outlined"
              shape="rounded"
              hideNextButton={true}
              hidePrevButton={true}
              renderItem={item => (
                <LabPaginationItem
                  classes={{
                    root: classes.itemRoot,
                    ellipsis: classes.itemEllipsis,
                    selected: classes.itemSelected
                  }}
                  {...item}
                />
              )}
              {...props}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Pagination;
